import classNames from "classnames";
import styles from "./styles.module.scss";

const renderPath = path => {
  let pathEl = null;
  if (parseInt(path) > 0) {
    pathEl = [];
    for (let i = 1; i <= path; i++) {
      pathEl.push(<span className={classNames(styles[`path${i}`])} key={i}></span>);
    }
  }
  return pathEl;
};

export default function IcoMoon({ className, icon, fontSize = 1, path = 0 }) {
  const fontSizePx = Math.ceil(fontSize * 14);
  return (
    <span className={classNames(styles[icon], styles.icon, className)} style={{ fontSize: `${fontSizePx}px` }}>
      {renderPath(path)}
    </span>
  );
}
